import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API from "../pages/Services/Baseservice";
import ClipLoader from "react-spinners/ClipLoader";
import { LanguageContext } from "../pages/languagecontext";
import CalendarIcon from "../assets/img/blog-images/.svg";

const SpecialNews = () => {
  const location = useLocation();
  const [newslist, setNewsList] = useState([]);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [view, setView] = useState("");
  const [loading, setLoading] = useState(true);
  const { selectedLanguage } = useContext(LanguageContext);
  const news = () => {
    navigate("/news");
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    if (id && id.news_id) {
      View(id.news_id);
      List(id.news_id);
    }
  }, [id, selectedLanguage.id]);
  const List = (newsId) => {
    let req = {
      search: "",
      rowsPerPage: "",
      page: "",
      language_id: selectedLanguage.id,
    };
    API.post("webnews_list/webCondition", req).then((response) => {
      if (response.data.success === true) {
        const all = response.data.data.data || [];

        const filtered = all.filter(
          (item) => Number(item.news_id) !== Number(newsId),
        );

        setNewsList(filtered.slice(0, 3));
      }
    });
  };
  const View = (newsId) => {
    let req = {
      news_id: newsId,
    };
    setLoading(true);
    API.post("webnews_view/webCondition", req).then((response) => {
      if (response.data.success === true) {
        setView(response.data.data.data || []);
        setLoading(false);
      }
    });
  };
  const handleReadMore = (item) => {
    View(item.news_id);
    List(item.news_id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center p-5 mt-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <>
          <div className="container asra mb-5 ">
            <p className="mt-4">
              <span className="newsnaviagtion" onClick={news}>
                {selectedLanguage.id === 1 ? "News" : "Nouvelles"}
              </span>{" "}
              &gt; {view.heading}
            </p>
            <h3 className="mt-4">{view.heading}</h3>
            <div className=" d-flex align-items-center gap-2 news-date mt-2">
              <img src={CalendarIcon} className="calendericon" alt="Date" />
              {view.date}
            </div>
            <div className="layerone">
              <p
                className="layers mt-4"
                dangerouslySetInnerHTML={{ __html: view.description }}
              ></p>

              {newslist?.length > 0 && (
                <div className="row more-news-row mt-5 ">
                  <h1 className="latestnewsinnews">
                    {selectedLanguage.id === 1
                      ? "More News"
                      : "Plus de nouvelles"}
                  </h1>
                  {newslist.map((item, index) => (
                    <div
                      key={index}
                      className="col-lg-4 col-md-6 mb-4 news-card"
                    >
                      <h3 className="mt-4 headline">{item.heading}</h3>

                      <div className=" d-flex align-items-center gap-2 news-date mt-2">
                        <img
                          src={CalendarIcon}
                          className="calendericon"
                          alt="Date"
                        />
                        {item.date}
                      </div>
                      <div className="layerone">
                        <p
                          className="layers mt-3 truncated-text"
                          dangerouslySetInnerHTML={{
                            __html: item.news_description,
                          }}
                        ></p>
                        <button
                          className="btn btn-link p-0 mt-2 read-more"
                          onClick={() => handleReadMore(item)}
                        >
                          {selectedLanguage.id === 1
                            ? "Read More"
                            : "Lire la suite"}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          {showScrollTop && (
            <button
              className="scroll-top-btn"
              aria-label="Scroll to top"
              onClick={scrollToTop}
            >
              <svg
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="12" y1="19" x2="12" y2="5"></line>
                <polyline points="5 12 12 5 19 12"></polyline>
              </svg>
            </button>
          )}
        </>
      )}
    </div>
  );
};
export default SpecialNews;
